// ** Initial State
const initialState = {
  allData: [],
  data: [],
  total: 1,
  params: {},
  selectedDocument: null
}

const documents = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ALL_DATA':
      return { ...state, allData: action.data }
    case 'GET_DOCUMENTS':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params
      }
    case 'ADD_DOCUMENT':
      return { ...state }
    case 'DELETE_DOCUMENT':
      return { ...state }
    case 'GET_DOCUMENT':
      return { ...state, selectedDocument: action.selectedDocument }
    case 'EDIT_DOCUMENT':
      return { ...state }
    default:
      return { ...state }
  }
}
export default documents
